import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-57df8759"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = { class: "option-group" }
const _hoisted_5 = { class: "option-label" }
const _hoisted_6 = { class: "option-group" }
const _hoisted_7 = { class: "option-label" }
const _hoisted_8 = { class: "option-row" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SecuritySubSettings } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { EngineLevel } from './engine-settings.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'engine-settings',
  props: {
  modelValue: {
    type: Object as PropType<SecuritySubSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const strategy = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val)
})

function handleChange() {
  emits('change')
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.engKvmTitle')), 1),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.engine_kvm_open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.engine_kvm_open) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engKvmEnable')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row indent",
        modelValue: strategy.value.engine_kvm_highlevel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.value.engine_kvm_highlevel) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly || !strategy.value.engine_kvm_open,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engKvmSensitive')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row indent",
        modelValue: strategy.value.engine_kvm_offline,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.value.engine_kvm_offline) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly || !strategy.value.engine_kvm_open,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engKvmOffline')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('groupPolicySettings.engKboostTitle')), 1),
            _createVNode(_component_el_checkbox, {
              class: "option-row",
              modelValue: strategy.value.engine_kboost_open,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.value.engine_kboost_open) = $event)),
              modelModifiers: { number: true },
              "true-label": 1,
              "false-label": 0,
              disabled: __props.readonly,
              onChange: handleChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engKboostEnable')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('groupPolicySettings.engAdvThreatTitle')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engMemoryLevel')) + " ", 1),
              _createVNode(_component_el_radio_group, {
                modelValue: strategy.value.engine_kwindhunter_level,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((strategy.value.engine_kwindhunter_level) = $event)),
                disabled: __props.readonly,
                onChange: handleChange,
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: _unref(EngineLevel).highest
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engLevelHighest')), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_radio, {
                    label: _unref(EngineLevel).strict
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engLevelStrict')), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_radio, {
                    label: _unref(EngineLevel).smart
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engLevelSmart')), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_radio, {
                    label: _unref(EngineLevel).normal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.engLevelNormal')), 1)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})